// Compiled at 2026-05-13T13:50:05.286Z
import * as LowgileDataUtil from "@lg/shared";
import * as Ramda from "ramda";
import * as $Modules from "../../Module/$modules.js";
import { Llama, Llama as This, System, Common } from "../../Module/$modules.js";
import type { HasId, IdType, Class, DeepReadonly, NominalType } from "@lg/shared";
import { Sys, ExecutionService } from "@lg/ng-shared";
// Auto-generated by Lowgile
import { Component, OnInit, AfterViewInit, Input, Output, EventEmitter, ChangeDetectionStrategy, inject, input, signal, computed, effect, linkedSignal, viewChild } from "@angular/core";
import { AppState, app } from "../../ClientDataStore/$state";
import { AbstractScreen } from "@lg/ng-shared";
import { ValidationRules, BoInfoSymbol } from "@lg/shared";
import { ProxyTargetSymbol } from "@lg/shared";
import { Semaphore } from "@lg/shared";
import { memoize } from "@lg/shared";
import { combineLatest } from "rxjs";
import { ProcessTaskComponent } from "../../components/process-task.component";
import { proxySignal, ProxySignal } from "../../signals.js";

interface Properties {
    chargeabilitiesOptions: { id: boolean, label: string }[];
    filterDateFrom: Date | null;
    filterDateTo: Date | null;
    filterProjectId: string | null;
    projectsOptions: This.Project[];
    filterChargeability: boolean | null;
    expenses: This.Expense[];
}

interface State {
    app: AppState;
    screen: Properties;
}

@Component({
    selector: 'Llama-MyExpenses',
    templateUrl: './MyExpenses.html',
    styleUrls: ['./MyExpenses.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class MyExpenses extends AbstractScreen implements OnInit, AfterViewInit {
    static readonly $canBeMainScreen = true;
    static readonly $canBeDialogScreen = true;
    readonly $qualifiedScreenName = 'Llama.MyExpenses';
    $isDialog = false;
    $Modules = $Modules;
    Llama = Llama;
    System = System;
    Common = Common;
    Sys = Sys;
    This = This;
    app = app;
    $scope = {};
    $pathSegments: string[] = [];
    $processTaskComponent = inject(ProcessTaskComponent, { optional: true });
    output = {

    };
    _DataTableBlock_columns_5 = (screen: Properties) => ['expenseDate', 'name', 'status', 'project', 'category', 'currency', 'vatAmount', 'tipAmount', 'totalAmount'];
    $validators: Record<number, ValidationRules> = {

    };
    var_chargeabilitiesOptions = proxySignal<{ id: boolean, label: string }[]>(undefined as any);
    var_filterDateFrom = proxySignal<Date | null>(undefined as any);
    var_filterDateTo = proxySignal<Date | null>(undefined as any);
    var_filterProjectId = proxySignal<string | null>(undefined as any);
    var_projectsOptions = proxySignal<This.Project[]>(undefined as any);
    var_filterChargeability = proxySignal<boolean | null>(undefined as any);
    var_expenses = proxySignal<This.Expense[]>(undefined as any);
    readonly screen =
        ((component: typeof this) => {
            return {
                get chargeabilitiesOptions() { return component.var_chargeabilitiesOptions() },
                set chargeabilitiesOptions(value: { id: boolean, label: string }[]) { component.var_chargeabilitiesOptions.set(value) },
                get filterDateFrom() { return component.var_filterDateFrom() },
                set filterDateFrom(value: Date | null) { component.var_filterDateFrom.set(value) },
                get filterDateTo() { return component.var_filterDateTo() },
                set filterDateTo(value: Date | null) { component.var_filterDateTo.set(value) },
                get filterProjectId() { return component.var_filterProjectId() },
                set filterProjectId(value: string | null) { component.var_filterProjectId.set(value) },
                get projectsOptions() { return component.var_projectsOptions() },
                set projectsOptions(value: This.Project[]) { component.var_projectsOptions.set(value) },
                get filterChargeability() { return component.var_filterChargeability() },
                set filterChargeability(value: boolean | null) { component.var_filterChargeability.set(value) },
                get expenses() { return component.var_expenses() },
                set expenses(value: This.Expense[]) { component.var_expenses.set(value) }
            }
        })(this)
        ;

    get $inputs() {
        return {

        }
    }

    async ngOnInit(): Promise<void> {
        super.ngOnInit()
        if (!this.$processTaskComponent) {
            this.processService.tokenId.set(undefined)
        }


    }

    async ngAfterViewInit(): Promise<void> {
    }

    constructor() {

        super()

        effect(() => {
            if (!this.authService.isInitialized()) return
            const isVariablesInitialized = this.$isVariablesInitialized()
            const { screen, app } = this
            if (!isVariablesInitialized) this.screen.chargeabilitiesOptions = ([])
            if (!isVariablesInitialized) this.screen.filterDateFrom = (null)
            if (!isVariablesInitialized) this.screen.filterDateTo = (null)
            if (!isVariablesInitialized) this.screen.filterProjectId = (null)
            if (!isVariablesInitialized) this.screen.projectsOptions = ([])
            if (!isVariablesInitialized) this.screen.filterChargeability = (null)
            if (!isVariablesInitialized) this.screen.expenses = ([])
            this.$isVariablesInitialized.set(true)
        })

        effect(() => {
            if (!this.$isVariablesInitialized()) return
            if (!this.$isOnInitCalled) {
                this.$isOnInitCalled = true
                setTimeout(async () => {
                    await this.action_onInit()
                    this.$isFullyInitialized.set(true)
                })
            }
        })

    }

    async handler_DatePickerBlock_20_dateChange_loadExpenses_0($event: any, $scope: any): Promise<void> {
        let { }: {} = $scope ?? {}

        {

            const { app, screen, output } = this
            try {
                await this.action_loadExpenses($event)
            } catch (err: any) {
                Sys.App.showError(err)
            }
            $event?.preventDefault?.()
            $event?.stopPropagation?.()
        }
    }

    async handler_DatePickerBlock_24_dateChange_loadExpenses_0($event: any, $scope: any): Promise<void> {
        let { }: {} = $scope ?? {}

        {

            const { app, screen, output } = this
            try {
                await this.action_loadExpenses($event)
            } catch (err: any) {
                Sys.App.showError(err)
            }
            $event?.preventDefault?.()
            $event?.stopPropagation?.()
        }
    }

    async handler_DropdownBlock_21_selectionChange_loadExpenses_0($event: any, $scope: any): Promise<void> {
        let { }: {} = $scope ?? {}

        {
            let selection: any = $event
            const { app, screen, output } = this
            try {
                await this.action_loadExpenses($event)
            } catch (err: any) {
                Sys.App.showError(err)
            }
            $event?.preventDefault?.()
            $event?.stopPropagation?.()
        }
    }

    async handler_DropdownBlock_25_selectionChange_loadExpenses_0($event: any, $scope: any): Promise<void> {
        let { }: {} = $scope ?? {}

        {
            let selection: any = $event
            const { app, screen, output } = this
            try {
                await this.action_loadExpenses($event)
            } catch (err: any) {
                Sys.App.showError(err)
            }
            $event?.preventDefault?.()
            $event?.stopPropagation?.()
        }
    }

    _DataTableBlock_collectionCodeSignal_5(component, $scope: any): any {

        return this.getMemoizedSignal(component, 'collectionCode', () =>
            computed(() => {
                let { app, screen, $pathSegments, $disabled }: { app: any, screen: any, $pathSegments: string[], $disabled: boolean } = $scope ?? {}
                return (screen.expenses)
            }, { equal: () => false })
        )

    }

    _DataTableBlock_additionalFindOptions_5($scope: any): any {
        let { app, screen, $pathSegments, $disabled }: { app: any, screen: any, $pathSegments: string[], $disabled: boolean } = $scope ?? {}

        return ({
            where: {
                employeeEmail: Sys.User.currentUser?.email,
                expenseDate: screen.filterDate ? This.ExpensesDataStore.LessThanOrEqual(screen.filterDate) : undefined,
                projectId: screen.filterProjectId
            }
        })
    }

    _DataTableColumnBlock_cellText_13($scope: any): any {
        let { app, screen, $pathSegments, $disabled, item, index }: { app: any, screen: any, $pathSegments: string[], $disabled: boolean, item: This.Expense, index: number } = $scope ?? {}

        return (Sys.Date.format(item.expenseDate, 'dd-MM-yyyy'))
    }

    _DataTableColumnBlock_cellText_14($scope: any): any {
        let { app, screen, $pathSegments, $disabled, item, index }: { app: any, screen: any, $pathSegments: string[], $disabled: boolean, item: This.Expense, index: number } = $scope ?? {}

        return (item.name)
    }

    _DataTableColumnBlock_cellText_22($scope: any): any {
        let { app, screen, $pathSegments, $disabled, item, index }: { app: any, screen: any, $pathSegments: string[], $disabled: boolean, item: This.Expense, index: number } = $scope ?? {}

        return (item.status.label)
    }

    _DataTableColumnBlock_cellText_23($scope: any): any {
        let { app, screen, $pathSegments, $disabled, item, index }: { app: any, screen: any, $pathSegments: string[], $disabled: boolean, item: This.Expense, index: number } = $scope ?? {}

        return (item.project?.name || 'N/A')
    }

    _DataTableColumnBlock_cellText_15($scope: any): any {
        let { app, screen, $pathSegments, $disabled, item, index }: { app: any, screen: any, $pathSegments: string[], $disabled: boolean, item: This.Expense, index: number } = $scope ?? {}

        return (item.category.label)
    }

    _DataTableColumnBlock_cellText_16($scope: any): any {
        let { app, screen, $pathSegments, $disabled, item, index }: { app: any, screen: any, $pathSegments: string[], $disabled: boolean, item: This.Expense, index: number } = $scope ?? {}

        return (item.currency.label)
    }

    _DataTableColumnBlock_cellText_17($scope: any): any {
        let { app, screen, $pathSegments, $disabled, item, index }: { app: any, screen: any, $pathSegments: string[], $disabled: boolean, item: This.Expense, index: number } = $scope ?? {}

        return (item.vatAmount)
    }

    _DataTableColumnBlock_cellText_18($scope: any): any {
        let { app, screen, $pathSegments, $disabled, item, index }: { app: any, screen: any, $pathSegments: string[], $disabled: boolean, item: This.Expense, index: number } = $scope ?? {}

        return (item.tipAmount)
    }

    _DataTableColumnBlock_cellText_19($scope: any): any {
        let { app, screen, $pathSegments, $disabled, item, index }: { app: any, screen: any, $pathSegments: string[], $disabled: boolean, item: This.Expense, index: number } = $scope ?? {}

        return (item.totalAmount)
    }

    async action_onInit($event?: any) {
        const { app, screen, output } = this
        {
            screen.projectsOptions = await This.ExpensesDataStore.loadByCondition(This.Project, {
                where: {
                    isActive: true
                }
            })
            screen.chargeabilitiesOptions = [
                { id: true, label: 'Yes' },
                { id: false, label: 'No' },
            ]

            screen.filterDateTo = new Date()
            screen.filterDateFrom = Sys.Date.fns.subMonths(screen.filterDateTo, 1)

            await this.action_loadExpenses($event)
        }
    }

    async action_loadExpenses($event?: any) {
        const { app, screen, output } = this
        {

            let expenseDateFilter = undefined;

            if (screen.filterDateFrom && screen.filterDateTo) {
                expenseDateFilter = This.ExpensesDataStore.Between(screen.filterDateFrom, screen.filterDateTo);
            } else {
                if (screen.filterDateFrom) {
                    expenseDateFilter = This.ExpensesDataStore.MoreThanOrEqual(screen.filterDateFrom)
                }

                if (screen.filterDateTo) {
                    expenseDateFilter = This.ExpensesDataStore.LessThanOrEqual(screen.filterDateTo)
                }
            }



            screen.expenses = await This.ExpensesDataStore.loadByCondition(This.Expense, {
                where: {
                    employeeEmail: Sys.User.currentUser?.email,
                    expenseDate: expenseDateFilter,
                    projectId: screen.filterProjectId || undefined,
                    isChargeable: screen.filterChargeability !== null ? screen.filterChargeability : undefined
                },
                relations: {
                    project: true
                }
            })
        }
    }
}
